import { motion } from "framer-motion";

// Subtle page transition wrapper.
export default function PageWrapper({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.35 }}
      className="page"
    >
      {children}
    </motion.div>
  );
}
